/**
 * @module M/impl/control/maritimesignalsControl
 */
export default class MaritimeSignalsControl extends M.impl.Control {
  constructor(format, featureCount, buffer) {
    super({});
    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map_ = null;
  }


  /**
   * This function adds the control to the specified map
   *
   * @public
   * @function
   * @param {M.Map} map to add the plugin
   * @param {HTMLElement} html of the plugin
   * @api
   */
  addTo(map, html) {
    this.map = map;
    super.addTo(map, html);
    map.getMapImpl().addControl(this);
  }

  /**
   * This function transform coordinates
   *
   * @public
   * @function
   * @param {Array} coord coordinates
   * @api
   */
  getProjTransform(coord, proj) {
    return ol.proj.transform(coord, 'EPSG:4326', proj);
  }

  /**
   * This function set style to feature
   *
   * @public
   * @function
   * @param {elm} feature
   * @param { Array } styles
   * @api
   */
  setStyle(elm, styles) {
    const stylesAux = [];
    styles.forEach((sty) => {
      stylesAux.push(sty.getImpl().olStyleFn()[1]);
    });
    elm.getImpl().getOLFeature().setStyle(stylesAux);
  }
}
